export default function (state) {
    let date = new Date();
    state.dateType = 1;
    state.dates = [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ];
    state.loadType = '';
    state.accountId = '';
}